import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { IEquipoModel } from '../features/equipos/models/EquipoModel';

@Injectable({
  providedIn: 'root',
})
export class EquipoService {
   constructor(private http: HttpClient) {}

  getEquipos() {
    return this.http.get<IEquipoModel[]>(`${environment.API_URL}/api/equipos`);
  }

  getEquiposByOwner(page: number, limit: number, search?: string) {
    const params: any = { page, limit };
    if (search) {
      params.search = search;
    }
    return this.http.get<{ items: IEquipoModel[]; total: number; page: number; limit: number }>(`${environment.API_URL}/api/equipos/owner`, { params });
  }


  getEquipoById(id: string) {
    return this.http.get<IEquipoModel>(`${environment.API_URL}/api/equipos/${id}`);
  }

  createEquipo(equipo: any) {
    return this.http.post(`${environment.API_URL}/api/equipos`, equipo);
  }

  vinculateEquipoToVessel(equipoId: string, vesselId: string) {
    return this.http.post(`${environment.API_URL}/api/equipos/vinculate`, { equipoId, vesselId });
  }

  desvinculateEquipoFromVessel(equipoId: string, vesselId: string) {
    return this.http.post(`${environment.API_URL}/api/equipos/desvinculate`, { equipoId, vesselId });
  }

  updateEquipo(id: string, equipo: any) {
    return this.http.put<any>(`${environment.API_URL}/api/equipos/${id}`, equipo);
  }

  deleteEquipo(id: string) {
    return this.http.delete(`${environment.API_URL}/api/equipos/${id}`);
  }
}
